import { EnrollmentHelpText, Button, DatePicker, SearchableSelect, Toast } from '@/shared/components'
import { StepHeader } from '../components/StepHeader'
import { ENROLLMENT_LOCATION_MESSAGES } from '../constants/enrollmentContent'
import { OnlineSessionConfirmationModal } from './scheduleAppointment/components/OnlineSessionConfirmationModal'
import { OnlineSessionSlots } from './scheduleAppointment/components/OnlineSessionSlots'
import { useScheduleAppointmentPage } from './scheduleAppointment/hooks/useScheduleAppointmentPage'

export function ScheduleAppointmentPage() {
  const {
    bookAppointment,
    bookingError,
    branchesLoading,
    canContinue,
    handleContinue,
    handleDatePickerChange,
    handleLocationSelect,
    handleOnlineRegistrationContinue,
    locationOptions,
    navigate,
    registeredOnlineSession,
    selectTimeSlot,
    selectedIsoDate,
    selectedLocationExternalId,
    selection,
    setBookingError,
    visibleWebinarEvents
  } = useScheduleAppointmentPage()

  return (
    <div className="bg-white px-4 py-10">
      <OnlineSessionConfirmationModal
        isOpen={registeredOnlineSession !== null}
        onContinue={handleOnlineRegistrationContinue}
      />
      {bookingError && <Toast message={bookingError} onClose={() => setBookingError(null)} />}
      <div className="mx-auto max-w-4xl animate-fade-in-up">
        <StepHeader currentStep={0} totalSteps={2} onBack={() => navigate('/application')} />

        <div className="mx-auto flex max-w-md flex-col gap-4 pt-2">
          <div className="mb-1 text-center animate-fade-in-up" style={{ animationDelay: '120ms' }}>
            <h3 className="modal-heading__title text-center">Schedule an Information Session</h3>
            <p className="mt-1 text-center text-sm text-gray-500">
              Live Online Presentation Available 5 Times Daily
            </p>
          </div>
          <div
            className="animate-fade-in-up relative z-[12000]"
            style={{ animationDelay: '120ms' }}
          >
            {branchesLoading ? (
              <div className="h-[52px] animate-pulse rounded-[8px] bg-gray-100" />
            ) : (
              <SearchableSelect
                label="Branch Location"
                options={locationOptions}
                value={selectedLocationExternalId ?? ''}
                onChange={handleLocationSelect}
                placeholder="Type to search branches..."
                disabled={locationOptions.length === 0}
              />
            )}
            {!branchesLoading && locationOptions.length === 0 ? (
              <p className="mt-2 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm leading-6 text-amber-900">
                {ENROLLMENT_LOCATION_MESSAGES.noBranches}
              </p>
            ) : null}
          </div>

          <div
            className="animate-fade-in-up relative z-[10000]"
            style={{ animationDelay: '200ms' }}
          >
            <DatePicker
              label="Meeting Date"
              value={selectedIsoDate}
              onChange={handleDatePickerChange}
              placeholder="MM/DD/YYYY"
              disablePast
            />
          </div>

          <OnlineSessionSlots
            selectedIsoDate={selectedIsoDate}
            selection={selection}
            visibleWebinarEvents={visibleWebinarEvents}
            onSelectTimeSlot={selectTimeSlot}
          />

          <div className="animate-fade-in-up" style={{ animationDelay: '280ms' }}>
            <Button
              type="button"
              onClick={handleContinue}
              disabled={!canContinue || bookAppointment.isPending}
              fullWidth
              className={canContinue ? 'hover:-translate-y-0.5 active:scale-95' : ''}
            >
              {bookAppointment.isPending ? 'Booking...' : 'Continue'}
            </Button>
          </div>

          <div className="text-center animate-fade-in-up" style={{ animationDelay: '340ms' }}>
            <EnrollmentHelpText />
          </div>
        </div>
      </div>
    </div>
  )
}
